import { useMutation } from '@tanstack/react-query';
import { DataExtractionService } from '@/infra/services/data-extraction';

interface useCreateDataExtractionQueueParams {
	organization_id: string;
	company_id: string;
	data_extraction_id: string;
}

const Service = DataExtractionService.getInstance();

export const useCreateDataExtractionQueue = () => {
	return useMutation({
		mutationFn: async (params: useCreateDataExtractionQueueParams) => Service.createDataExtractionQueue(params)
	});
};
